// NetworkErrorAlert.js
import React, { useEffect, useState } from "react";
import { showMessage } from "store/base/messageSlice";
import { useDispatch } from "react-redux";

const NetworkErrorAlert = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!navigator.onLine) {
      dispatch(
        showMessage({
          title: "Network Error",
          message: "Please check your internet connection.",
          position: "top-center",
          type: "danger",
        })
      );
    }
  }, []);

  return <></>;
};

export default NetworkErrorAlert;
